<template lang="html">
  <div class="">

    <div class="twoColumnGrid">
      <div class="search-bar">
        <tl-search @change="searchEmp"></tl-search>
      </div>
      <div class="import-btn-grp">
        <btn-grp>
          <btn text="New" type="primary" @click="newLoan" />
          <btn text="Import" type="primary" @click="importLoan" />
          <btn text="Import History" type="secondary" @click="importHistoryLoan" />
        </btn-grp>
      </div>
    </div>

    <div class="margin-top-30">
      <data-table :columns="columnNames" :tableData="loansData" :checkbox="false" :showinrow="false">
        <!-- <template v-slot:rowcontent="slotprops">{{loansData[slotprops.value.index]}}
            <div class="action-section" v-if="slotprops.value.column.key=='action'"> 
              <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon">
              <ul class="action-menu" v-show="loansData[slotprops.value.index].showDropDown" >
                  <li> <span class="">View/Edit</span></li>
                  <li><span class="">Delete </span></li>
              </ul>
            </div>
        </template> -->
      </data-table>
    </div>


    <div class="btn-group">
      <bottom-action-container>
        <btn-grp slot="end">
          <btn text="Close" type="secondary" @click="close" />
        </btn-grp>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "loanCalculation",
    computed: {
      ...mapState({}),
      ...mapGetters({
        orgid: "onboard/organization/orgid"
      })
    },
    data() {
      return {
        columnNames: [
          {
            label: "Sl.No",
            key: "slno"
          },
          {
            label: "Code",
            key: "code"
          },
          {
            label: "Name",
            key: "name"
          },
          {
            label: "Disbursement Date",
            key: "disbursementDate"
          },
          {
            label: "Start Date",
            key: "startDate"
          },
          {
            label: "Loan Amount",
            key: "loanAmount"
          },
          {
            label: "Recovery Type",
            key: "recoveryType"
          },
          {
            label: "Interest Type",
            key: "interestType"
          },
          {
            label: "Loan Status",
            key: "loanStatus"
          },
          {
            label: "Action",
            key: "action"
          }
        ],
        loansData: [
          {
            id: 11,
            slno: 1,
            code: "abcd1234",
            name: "Adhaar Card",
            disbursementDate: "23 Jun 2019",
            startDate: "23 Jun 2019",
            loanAmount: "10000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Closed",
            action: "",
            showDropDown: false
          },
          {
            id: 22,
            slno: 2,
            code: "abcd1234",
            name: "Adhaar Card",
            disbursementDate: "23 Jun 2019",
            startDate: "23 Jun 2019",
            loanAmount: "10000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Closed",
            action: "",
            showDropDown: false
          },
          {
            id: 33,
            slno: 3,
            code: "abcd1234",
            name: "Adhaar Card",
            disbursementDate: "23 Jun 2019",
            startDate: "23 Jun 2019",
            loanAmount: "10000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Closed",
            action: "",
            showDropDown: false
          },
          {
            id: 44,
            slno: 4,
            code: "abcd1234",
            name: "Adhaar Card",
            disbursementDate: "23 Jun 2019",
            startDate: "23 Jun 2019",
            loanAmount: "10000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Closed",
            action: "",
            showDropDown: false
          }
        ]
      };
    },
    mounted() { },

    methods: {
      ...mapActions({}),

      dropdown(slots) {
        let idx = this.loansData.findIndex(obj => {
          return obj.id == slots.index + 1;
        });
        this.loansData.forEach((data, index) => {
          if (index != idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.loansData[slots.index].showDropDown = !this.loansData[slots.index]
            .showDropDown;
        }
      },

      searchEmp() { },

      newLoan() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loanMaster`
        });
      },

      importLoan() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/importEmployeeLoans`
        });
      },

      importHistoryLoan() { },

      close() { }
    }
  };
</script>

<style lang="scss" scoped>

  .margin-top-30{
    margin-top: 30px;
  }
  .action-section {
    margin: 0px;
    text-align: center;

    img {
      width: auto;
    }
    .action-menu {
      top: 0px;
      right: 54px;
      left: -182px;
      li {
        padding: 0px;
        padding: 10px 25px;
        font-weight: 500;
        &:not(:last-child) {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }

  .search-bar {
    padding: 30px 0px 0px 0px;
    display: flex;
  }

  .import-btn-grp {
    padding: 25px 0px 0px 0px;
    display: flex; // max-height: 50px;
  }
</style>